exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".arrow-button {\n  border: none;\n  background: none;\n  padding-top: 2px;\n  padding-bottom: 2px;\n  cursor: pointer;\n  transition-duration: 0.3s; }\n  .arrow-button.active, .arrow-button.focuse {\n    outline: none; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/_atomic/ArrowButton/ArrowButton.scss
// module id = 1281
// module chunks = 0